import { render, staticRenderFns } from "./SalesPrediction.vue?vue&type=template&id=5d558d76&scoped=true&"
import script from "./SalesPrediction.vue?vue&type=script&lang=js&"
export * from "./SalesPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d558d76",
  null
  
)

export default component.exports